import styled, { css } from "styled-components";
import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  IconButton
} from "@material-ui/core";
import { Scrollbar } from "../../common/Scrollbar";

export const Dialog = styled(MuiDialog)`
	.MuiPaper-root {
		background: ${props => props.theme.palette.primary.main};
		box-shadow: none;
		width: ${props => props.theme.widthRatio*1174}px;
		max-width: unset;
		max-height: ${props => props.theme.heightRatio*810}px;
		margin-top: ${props => props.theme.heightRatio*120}px;
		padding: ${props => props.theme.heightRatio*48}px
		         ${props => props.theme.widthRatio*22}px
		         ${props => props.theme.heightRatio*42}px
		         ${props => props.theme.widthRatio*59}px;
		align-items: center;
		border-radius: 10px;
		position: relative;
		margin-left: ${props => props.theme.widthRatio * 320}px;
		
    ${props => props.theme.name === 'dark' && css`
      border: 1px solid ${props => props.theme.palette.secondary.main};
    `}
  
    ${props => props.theme.name === 'light' && css`
      box-shadow: 0 2px 32px 4px rgba(0,0,0,0.2);
    `}
    
    ${props => props.aligncenter === 'active' && css`
      margin: 0 auto !important;
    `}
    
    .pdf-content {
      display: none;
      background: white;
      color: #1F1F1F !important;

      p, h1, h5 {
        color: #1F1F1F !important;
      }

      .pl1 {
        padding-left: ${props => props.theme.widthRatio * 5}px;
      }

      .text-bold {
        font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Bold;
      }

      a {
        color: #FFBD59 !important;
      }

      .table {
        .table-row {
          &:nth-child(2n+1) {
            background-color: #E8E8E9 !important;
          }
        }
      }
    }
	}
`;

export const DialogContent = styled(MuiDialogContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 !important;
	color: ${props => props.theme.palette.third[100]}
	text-align: center;
	
	h4 {
		font: ${props => props.theme.widthRatio*30}px/${props => props.theme.heightRatio*40}px SFProRounded-Bold;
		margin: 0 0 ${props => props.theme.widthRatio*38}px;
		color: ${props => props.theme.palette.third["100"]};
	}
	
	p {
	  font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	  color: ${props => props.theme.palette.third["100"]};
	  margin: 0;
	  text-align: justify;
	}
`;

export const CloseButton = styled(IconButton)`
  padding: 0;
  width: ${props => props.theme.widthRatio * 40}px;
  height: ${props => props.theme.widthRatio * 40}px;
  position: absolute;
  right: ${props => props.theme.widthRatio * 10}px;
  top: ${props => props.theme.widthRatio * 13}px;
  cursor: pointer;
  font: ${props => props.theme.widthRatio*26}px/${props => props.theme.heightRatio*35}px SFProRounded-Bold;
  color: ${props => props.theme.palette.third[100]};
`;

export const ScrollbarWrapper = styled(Scrollbar)`
  padding-right: ${props => props.theme.widthRatio*30}px;
  
  .main-list {
    padding: 0;
  }
  
  .pl1 {
    padding-left: ${props => props.theme.widthRatio * 5}px;
  }
  
  p {
    font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
  }
  
  .text-bold {
    font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Bold;
  }
`;

export const DownloadButton = styled(MuiButton)`
	width: ${props => props.theme.widthRatio*188}px;
	height: ${props => props.theme.heightRatio*45}px;
	color: #1F1F1F;
	background-color: ${props => props.theme.palette.secondary.main};
	font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Bold;
	margin-top: ${props => props.theme.heightRatio * 37}px;
	
  &:hover {
    background-color: ${props => props.theme.palette.secondary[50]};
  }
`;

export const MainList = styled.ol`
  padding-left: ${props => props.theme.widthRatio * 36}px;
  
  h5 {
    font: ${props => props.theme.widthRatio * 24}px/${props => props.theme.heightRatio * 32}px SFProRounded-Bold;
    margin: ${props => props.theme.heightRatio * 40}px 0 ${props => props.theme.heightRatio * 15}px -${props => props.theme.widthRatio * 30}px;
    color: ${props => props.theme.palette.third["100"]};
  }
  
  > li {
    font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
    padding-left: ${props => props.theme.widthRatio * 26}px;
    color: ${props => props.theme.palette.third["100"]};
    
    p {
      margin-bottom: ${props => props.theme.heightRatio * 10}px;
      color: ${props => props.theme.palette.third["100"]};
      
      a {
        color: ${props => props.theme.palette.secondary.main};
      }
    }
  }
  
  .sub-list {
    list-style-type: lower-alpha;
    padding-left: ${props => props.theme.widthRatio * 25}px;
    margin-left: ${props => props.theme.widthRatio * 10}px;
    
    > li {
      padding-left: ${props => props.theme.widthRatio * 7}px;
    }
    
    > p {
      margin-left: -${props => props.theme.widthRatio * 25}px;
    }
  }
  
  .table {
    border: 1px solid;
    margin: ${props => props.theme.heightRatio * 15}px 0;
  
    .table-row {
      display: flex;
      border-bottom: 1px solid;
      
      &:nth-child(2n+1) {
        background-color: ${props => props.theme.palette.primary[900]};
      }
      
      .table-cell {
        flex: 1;
        border-right: 1px solid;
        padding: ${props => props.theme.heightRatio * 5}px ${props => props.theme.widthRatio * 10}px;
        font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
        color: ${props => props.theme.palette.third["100"]};
        
        :last-child {
          border-right: 0;
        }
        
        &.w-33 {
          flex: unset;
          width: 33%;
        }
        
        &.w-15 {
          flex: unset;
          width: 15%;
        }
        
        &.text-left {
          text-align: left;
        }
        
        &.border-0 {
          border: 0;
        }
      }
    }
    
    .table-head {
      text-align: center;
      .table-cell {
        font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Bold;
      }
    }
    
    .table-body {
      .table-row {
        :last-child {
          border-bottom: 0;
        }
      }
    }
  }
`;
